<template>
    <el-select placeholder="Valitse" size="small" style="width: 240px">
        <slot></slot>
    </el-select>
</template>
